'use strict';

module.exports = function (str) {
    if (this.options.debugMode) {
        console.log(str + '%c', 'color: #009ACD');
    }
};


//////////////////
// WEBPACK FOOTER
// /home/giant/builds/t1_QpaSbS/0/kpmg/plan-k.cz/node_modules/swup/lib/modules/log.js
// module id = 50
// module chunks = 3